/* @generated from adl module ferovinum.datacontracts.deallegsale */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface DealLegSaleRawRecord {
  id: common_strings.StringNE;
  saleOrderId: common_strings.StringNE;
  dealLegId: common_strings.StringNE;
  saleUnits: common_strings.StringNE;
  quantitySold: common.BigDecimal;
  forwardSalePrice: common.BigDecimal;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeDealLegSaleRawRecord(
  input: {
    id: common_strings.StringNE,
    saleOrderId: common_strings.StringNE,
    dealLegId: common_strings.StringNE,
    saleUnits: common_strings.StringNE,
    quantitySold: common.BigDecimal,
    forwardSalePrice: common.BigDecimal,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): DealLegSaleRawRecord {
  return {
    id: input.id,
    saleOrderId: input.saleOrderId,
    dealLegId: input.dealLegId,
    saleUnits: input.saleUnits,
    quantitySold: input.quantitySold,
    forwardSalePrice: input.forwardSalePrice,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const DealLegSaleRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.deallegsale","decl":{"annotations":[{"value":{"datasetName":"raw_deal_leg_sale"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"saleUnits","default":{"kind":"nothing"},"name":"saleUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"quantitySold","default":{"kind":"nothing"},"name":"quantitySold","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"forwardSalePrice","default":{"kind":"nothing"},"name":"forwardSalePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"DealLegSaleRawRecord","version":{"kind":"nothing"}}};

export const snDealLegSaleRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.deallegsale", name:"DealLegSaleRawRecord"};

export function texprDealLegSaleRawRecord(): ADL.ATypeExpr<DealLegSaleRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snDealLegSaleRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.deallegsale.DealLegSaleRawRecord" : DealLegSaleRawRecord_AST
};
